import { useEffect, useState } from 'react';
import ResizeObserverPolyfill from 'resize-observer-polyfill';

export const useRootWidth = (rootElement) => {
  const [width, setWidth] = useState(0);

  // We should update state of UI buttons each time carousel resizes
  useEffect(() => {
    if (!rootElement) {
      return undefined;
    }

    setWidth(rootElement.clientWidth);
    const resizeObserver = new ResizeObserverPolyfill(() => {
      if (rootElement) {
        setWidth(rootElement.clientWidth);
      }
    });
    resizeObserver.observe(rootElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [rootElement]);

  return width;
};
